function normalizeSsoPath(url) {
    const value = String(url || '').trim()
    if (!value) {
        return ''
    }

    if (/^https?:\/\//i.test(value)) {
        try {
            return new URL(value).pathname.replace(/^\//, '').toLowerCase()
        } catch {
            return value.replace(/^\//, '').toLowerCase()
        }
    }

    return value.replace(/^\//, '').toLowerCase()
}

export function isSonaeSsoLogoutPath(url) {
    const path = normalizeSsoPath(url)
    return path.startsWith('auth/logout/sonae') || path === 'logout/sonae'
}

export function isSonaeSsoLoginPath(url) {
    const path = normalizeSsoPath(url)
    if (!path) {
        return false
    }

    return path.startsWith('auth/login/sonae') || path === 'login/sonae'
}

function getAppSsoLoginUrls(config) {
    if (!config || !config.sso) {
        return []
    }

    return ['saml_url_app', 'saml_url']
        .map((key) => config.sso[key])
        .filter((url) => String(url || '').trim() !== '')
}

export function hasSonaeOidcAppLogin(config) {
    return getAppSsoLoginUrls(config).some((loginUrl) => {
        const login = String(loginUrl || '').trim()
        return login && isSonaeSsoLoginPath(login) && normalizeSsoPath(login).includes('/oidc')
    })
}

export function isSonaeOidcSsoConfig(config) {
    if (!hasSonaeOidcAppLogin(config)) {
        return false
    }

    const logoutUrl = String(config.sso.url_logout || '').trim()
    return Boolean(logoutUrl && isSonaeSsoLogoutPath(logoutUrl))
}

export function shouldSkipLegacyExternalUserLogout(config) {
    return isSonaeOidcSsoConfig(config)
}

export function isSonaeSsoConfig(config) {
    return isSonaeOidcSsoConfig(config)
}

export function getSsoLogoutUrl(config) {
    if (!isSonaeSsoConfig(config)) {
        return null
    }

    const url = String(config.sso.url_logout).trim()
    return url !== '' ? url : null
}

export function buildSsoLogoutFullUrl(config, defaultApiUrl) {
    const logoutUrl = getSsoLogoutUrl(config)
    if (!logoutUrl) {
        return null
    }

    if (/^https?:\/\//i.test(logoutUrl)) {
        return logoutUrl
    }

    const apiUrl = String((config && config.api) || defaultApiUrl || process.env.VUE_APP_API_URL || '').trim()
    if (!apiUrl) {
        return null
    }

    const base = apiUrl.endsWith('/') ? apiUrl : `${apiUrl}/`
    return base + logoutUrl.replace(/^\//, '')
}

export function redirectToSsoLogout(config, options = {}) {
    const fullUrl = buildSsoLogoutFullUrl(config, options.apiUrl || process.env.VUE_APP_API_URL)
    if (!fullUrl) {
        return false
    }

    const isCordovaApp =
        typeof options.isApp === 'boolean'
            ? options.isApp
            : typeof window !== 'undefined' && window.cordova && process.env.VUE_APP_IS_APP === 'TRUE'

    if (isCordovaApp && typeof cordova !== 'undefined' && cordova.InAppBrowser) {
        cordova.InAppBrowser.open(fullUrl, '_system')
    } else {
        window.location.href = fullUrl
    }

    return true
}

export function isSsoLogoutRedirect(result) {
    return Boolean(result && result.ssoRedirect)
}

export function finishWithSsoLogoutRedirect(config, options = {}) {
    if (redirectToSsoLogout(config, options)) {
        return { ssoRedirect: true }
    }

    return { ssoRedirect: false }
}

export function navigateToLoginAfterLogout(router, result) {
    if (isSsoLogoutRedirect(result)) {
        return Promise.resolve()
    }

    return router.push('/login').then(function () {
        location.reload()
    })
}
